import { ServiceBase } from '../api/ServiceBase'


const endpoint = 'agricultores'
const endpointLimited = 'limited'
const endpointDesativarAgricultor = 'desativar_agricultor'

async function getAgricultores(todos) {

    try {
        var data = await ServiceBase.getByParams(`${endpoint}/${endpointLimited}`, { 'is_ativo': todos ? 'True' : 'False' });
        return data;
    } catch (e) {
        throw e;
    }

}

async function getAgricultorById(id) {

    try {
        var data = await ServiceBase.getByParams(`${endpoint}/${id}`);
        return data;
    } catch (e) {
        throw e;
    }
}

async function postAgricultor(agricultor) {
    try {
        var data = await ServiceBase.postData(endpoint, agricultor)
        return data;
    } catch (e) {
        throw e;
    }
}

async function putAgricultor(agricultor) {
    try {
        var data = await ServiceBase.putData(`${endpoint}/${agricultor.id}/`, agricultor)
        return data;
    } catch (e) {
        throw e;
    }
}


async function desativarOrAtivarAgricultor(id, ativar) {
    try {
        var data = await ServiceBase.putData(`${endpoint}/${endpointDesativarAgricultor}/`, { 'id': id, 'is_ativo': ativar ? 'True' : 'False' })
        return data;
    } catch (e) {
        throw e;
    }
}

export const AgricultorService = {
    getAgricultores,
    getAgricultorById,
    postAgricultor,
    putAgricultor,
    desativarOrAtivarAgricultor
}